import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../store/auth'
import { Botao, Erro } from '../components/ui'
import { mensagemDeErro } from '../components/CampoDeSenha'

/**
 * Pedir o link de redefinição.
 *
 * A tela confirma que o pedido foi feito, e NÃO se o e-mail existe. O Upgrade
 * ID responde igual nos dois casos de propósito: diferenciar transformaria
 * esta página num verificador de quem tem conta nos sete produtos.
 */
export default function Esqueci() {
  const pedirRedefinicao = useAuth((s) => s.pedirRedefinicao)
  const [email, setEmail] = useState('')
  const [erro, setErro] = useState('')
  const [indo, setIndo] = useState(false)
  const [pronto, setPronto] = useState(false)

  async function enviar(e) {
    e.preventDefault()
    setErro(''); setIndo(true)
    try {
      await pedirRedefinicao(email)
      setPronto(true)
    } catch (err) {
      setErro(mensagemDeErro(err))
    } finally { setIndo(false) }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-6">
      <div className="flex w-full max-w-sm flex-col gap-4 rounded-xl border border-zinc-200 bg-white p-7">
        <div>
          <h1 className="text-lg font-semibold text-zinc-900">Esqueci a senha</h1>
          <p className="text-sm text-zinc-500">Mandamos um link por e-mail.</p>
        </div>

        {pronto ? (
          <>
            <p className="text-sm leading-relaxed text-zinc-600">
              Se existe uma conta com esse e-mail, o link já está a caminho. Ele vale por
              30&nbsp;minutos e só funciona uma vez.
            </p>
            <Link to="/" className="text-sm text-pinho-700 hover:underline">voltar para o login</Link>
          </>
        ) : (
          <form onSubmit={enviar} className="flex flex-col gap-4">
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="e-mail" autoComplete="username"
              className="rounded-lg border border-zinc-300 px-3 py-2 text-sm"
            />
            <Erro>{erro}</Erro>
            <Botao type="submit" disabled={indo}>{indo ? 'enviando…' : 'Mandar o link'}</Botao>
            <Link to="/" className="text-center text-sm text-zinc-500 hover:text-zinc-800">
              voltar para o login
            </Link>
          </form>
        )}
      </div>
    </div>
  )
}
